import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-participantes-edit',
  templateUrl: './participantes-edit.component.html',
  styleUrls: ['./participantes-edit.component.css'],
  standalone: false
})
export class ParticipantesEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/participantes`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Participantes', link: '/participantes' }, { label: 'Edição Participantes' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'participantes',
      // saveNew: '/cliente',
  };

  fields: PoPageDynamicEditField[] = []
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;


  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema("participantes").subscribe((data) => {
        this.fields = data;
    });
  }

}
